export default __webpack_public_path__ + "2020 Molecular polaritons for controlling chemistry with quantum optics.pdf";